import { render } from "./DeleteUserDialog.vue?vue&type=template&id=003ed4f9"
import script from "./DeleteUserDialog.vue?vue&type=script&lang=js"
export * from "./DeleteUserDialog.vue?vue&type=script&lang=js"

import "./DeleteUserDialog.vue?vue&type=style&index=0&id=003ed4f9&lang=scss"

import exportComponent from "/home/iskra/Projects/verum/admin-panel/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__